import { useState, useEffect, } from "react";
import { useContext,} from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./PFRefluxCond2.css";
import { WellContext } from "../context/WellContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import LaboratoryAnalysisFaceplate from "../components/LaboratoryAnalysisFaceplate";
import { crudeDatabase } from "../data/crudeDatabase";




import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function PFRefluxCond2() {

    useEffect(() => {
    
      trackPageVisit("PFRefluxCond2");
    
    }, []);
  
     const {toggleValve, valves} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);
  const [showLab,setShowLab] = useState(false); 
  const [showLabFaceplate, setShowLabFaceplate] = useState(false);

  const DEFAULT_VALVES = {
  FCV_18001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_18002: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_18003: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("PFRefluxCond2_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_18001: { ...DEFAULT_VALVES.FCV_18001, ...parsed.FCV_18001 },
      FCV_18002: { ...DEFAULT_VALVES.FCV_18002, ...parsed.FCV_18002 },
      FCV_18003: { ...DEFAULT_VALVES.FCV_18003, ...parsed.FCV_18003 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("PFRefluxCond2_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};






const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF FLASHED HYDROCARBONS FROM T-101 =================

const PreFlashOverheadComposition =
  JSON.parse(
    localStorage.getItem(
      "PreFlashOverheadComposition"
    )
  ) || {};

const PreFlashOverheadFlow =
  Number(
    localStorage.getItem(
      "PreFlashOverheadFlow"
    )
  ) || 0;



  const LightNaphthaOverhead =
  PreFlashOverheadFlow *
  (
    PreFlashOverheadComposition.LightNaphtha || 0
  ) / 100;

const HeavyNaphthaOverhead =
  PreFlashOverheadFlow *
  (
    PreFlashOverheadComposition.HeavyNaphtha || 0
  ) / 100;

const KeroseneOverhead =
  PreFlashOverheadFlow *
  (
    PreFlashOverheadComposition.Kerosene || 0
  ) / 100;


const flashedComposition =
  JSON.parse(
    localStorage.getItem("OverheadComposition")
  ) || {};


  const totalOverhead =

(flashedComposition?.LightNaphthaFeed || 0) +
(flashedComposition?.HeavyNaphthaFeed || 0) +
(flashedComposition?.KeroseneFeed || 0) +
(flashedComposition?.DieselFeed || 0) +
(flashedComposition?.VGOFeed || 0) +
(flashedComposition?.ResidueFeed || 0);



const lightNaphthaPct =
((flashedComposition?.LightNaphthaFeed || 0)
 / totalOverhead) * 100;

const heavyNaphthaPct =
((flashedComposition?.HeavyNaphthaFeed || 0)
 / totalOverhead) * 100;

const kerosenePct =
((flashedComposition?.KeroseneFeed || 0)
 / totalOverhead) * 100;

const dieselPct =
((flashedComposition?.DieselFeed || 0)
 / totalOverhead) * 100;

const vgoPct =
((flashedComposition?.VGOFeed || 0)
 / totalOverhead) * 100;

const residuePct =
((flashedComposition?.ResidueFeed || 0)
 / totalOverhead) * 100;


 const selectedCrude =
localStorage.getItem(
"MDS_selectedCrude"
);

const crude =
crudeDatabase[selectedCrude];



const IBP =
crude?.tbpDistillation?.[70]?.value || 0;

const TBP10 =
crude?.tbpDistillation?.[72]?.value || 0;

const TBP20 =
crude?.tbpDistillation?.[73]?.value || 0;

const TBP30 =
crude?.tbpDistillation?.[74]?.value || 0;

const TBP40 =
crude?.tbpDistillation?.[75]?.value || 0;

const TBP50 =
crude?.tbpDistillation?.[76]?.value || 0;

const FBP =
crude?.tbpDistillation?.[82]?.value || 0;



const openLabAnalysis = () => {
   console.log("LAB REPORT CLICKED");
  localStorage.setItem(
  "CurrentLabSample",
  JSON.stringify({
    source: "PFRefluxCond2",
    crude: localStorage.getItem("MDS_selectedCrude"),
    composition: flashedComposition,
    sampleDate: new Date().toISOString()
  })
);
  setShowLabFaceplate(true);
};

// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
            const { transmitters, flowOverrides } = usePlantStore();
            const TT_17003 = transmitters.TT_17003 || 0;
            const PT_17002 = transmitters.PT_17002 || 0;
            const FIC_17001 = transmitters.FIC_17001 || 0;
            const NaphthaRefluxFCV = transmitters.NaphthaRefluxFCV || 0;
  
const VaporIn =
  Number(
    localStorage.getItem(
      "PreFlashOverheadFlow"
    )
  ) || 0;




    const xv18001Open = !valves?.XV_18001;
    const xv18002Open = !valves?.XV_18002;
    const xv18003Open = !valves?.XV_18003;
    const xv18004Open = !valves?.XV_18004;
    const xv18005Open = !valves?.XV_18005;
    const xv18006Open = !valves?.XV_18006;
    const xv18007Open = !valves?.XV_18007;


  
  
// BACKPRESSURE EFFECT AS A RESULT OF GAS OUTLET VALVE CLOSURE

    let BackPressureFactor = 0;

    if (
      !xv18006Open &&
      VaporIn > 0.1
    )
    {
      BackPressureFactor =
        Math.min(
          1.5,
          VaporIn * 0.05
        );
    }

    localStorage.setItem(
        "BackPressureFactor",
        BackPressureFactor
      );



    const FIC_18001 = FIC_17001;
    const TT_18001 = TT_17003;
    const PT_18001 = PT_17002 + (BackPressureFactor * 0.80);
    
    const FIC_18011 = xv18003Open ? 0.435 : 0;

    const FIC_18002 = xv18004Open ? 0.123 : 0;
    const FIC_18003 = xv18005Open ? 0.0923 : 0;




/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};


/* =========================================================
   P-102A / B STATUS
========================================================= */

const P102A_Running =
  pumpData?.["P-102A"]?.running ?? false;

const P102B_Running =
  pumpData?.["P-102B"]?.running ?? false;

const P102_Running =
  P102A_Running || P102B_Running;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P102_CAPACITY = 6.456;


/* =========================================================
   FCV OPENINGS
========================================================= */

const FCV18001_Opening =
  (valveData?.FCV_18001?.opening || 0) / 100;

const FCV18004_Opening = NaphthaRefluxFCV;


/* =========================================================
   TOTAL OPENING
========================================================= */

const totalOpening =
  FCV18001_Opening +
  FCV18004_Opening;


/* =========================================================
   PUMP UTILIZATION
========================================================= */

const PumpUtilization =
  Math.min(totalOpening, 1);


/* =========================================================
   AVAILABLE PUMP FLOW
========================================================= */

const PumpAvailableFlow =
  P102_Running
    ? P102_CAPACITY * PumpUtilization
    : 0;


/* =========================================================
   TARGET FLOWS
========================================================= */

const targetFIC_18004 =
  totalOpening > 0
    ? PumpAvailableFlow *
      (FCV18001_Opening / totalOpening)
    : 0;


const targetFIC_18005 =
  totalOpening > 0
    ? PumpAvailableFlow *
      (FCV18004_Opening / totalOpening)
    : 0;


/* =========================================================
   FIC-18004 (TO TANK)
========================================================= */

const FIC_18004 = flowOverrides?.FIC_18006 ? 0 :
  (processData.FIC_18004 || 0);

useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_18004 || 0);

      const target =
        Number(targetFIC_18004 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_18004: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_18004]);

/* =========================================================
   FIC-18005 (REFLUX)
========================================================= */

const FIC_18005 = flowOverrides?.FIC_18006 ? 0 :
  (processData.FIC_18005 || 0);

useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_18005 || 0);

      const target =
        Number(targetFIC_18005 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_18005: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_18005]);

/* =========================================================
   TOTAL PUMP FLOW
========================================================= */

const FIC_18006 = 
  (Number(
    (
      FIC_18004 +
      FIC_18005
    ).toFixed(3)
  ));

useEffect(() => {

  setProcessData(prev => {

    if (prev.FIC_18006 === FIC_18006) {
      return prev;
    }

    return {
      ...prev,
      FIC_18006
    };

  });

}, [FIC_18006]);

/* =========================================================
   DISCHARGE PRESSURE
========================================================= */

const PT_18002 =
  P102_Running &&
  totalOpening > 0
    ? 0.983
    : 0.03;


/* =========================================================
   DISCHARGE TEMPERATURE
========================================================= */

const TT_18002 =
  P102_Running
    ? Number(TT_18001 || 25)
    : 25;





    
/* =========================================================
              SPLITTING MAIN LINE OF P-102A/B
========================================================= */

const PreFlashedNaphthaSplit =
[
  xv18001Open,
  xv18002Open
  ].filter(Boolean).length;

const FIC_18007 =
  xv18001Open
    ? FIC_18004 / PreFlashedNaphthaSplit
    : 0;

const FIC_18008 =
  xv18002Open
    ? FIC_18004 / PreFlashedNaphthaSplit
    : 0;



const PT_18007 = xv18001Open ? PT_18002 : 0.03;
const TT_18007 = xv18001Open ? TT_18002 : 32;

const PT_18008 = xv18002Open ? PT_18002 : 0.03;
const TT_18008 = xv18002Open ? TT_18002 : 32;





/* =========================================================
   P-109 STATUS
========================================================= */

const P109_Running =
  pumpData?.["P-109"]?.running ?? false;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P109_CAPACITY = 0.8;


/* =========================================================
   FCV OPENINGS
========================================================= */

const FCV18002_Opening =
  (valveData?.FCV_18002?.opening || 0) / 100;

const FCV18003_Opening =
  (valveData?.FCV_18003?.opening || 0) / 100;


/* =========================================================
   TOTAL OPENING
========================================================= */

const totalOpening109 =
  FCV18002_Opening +
  FCV18003_Opening;


/* =========================================================
   PUMP UTILIZATION
========================================================= */

const PumpUtilization109 =
  Math.min(totalOpening109, 1);


/* =========================================================
   AVAILABLE PUMP FLOW
========================================================= */

const PumpAvailableFlow109 =
  P109_Running
    ? P109_CAPACITY * PumpUtilization109
    : 0;


/* =========================================================
   TARGET FLOWS
========================================================= */

const targetFIC_18009 =
  totalOpening109 > 0
    ? PumpAvailableFlow109 *
      (FCV18002_Opening / totalOpening109)
    : 0;


const targetFIC_18010 =
  totalOpening109 > 0
    ? PumpAvailableFlow109 *
      (FCV18003_Opening / totalOpening109)
    : 0;


/* =========================================================
   FIC-18009 (TO T-101)
========================================================= */

const FIC_18009 = flowOverrides?.FIC_18009 ? 0 :
  (processData.FIC_18009 || 0);

useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_18009 || 0);

      const target =
        Number(targetFIC_18009 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_18009: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_18009]);

/* =========================================================
   FIC-18010 (TO T-102)
========================================================= */

const FIC_18010 = flowOverrides?.FIC_18010 ? 0 :
  (processData.FIC_18010 || 0);

useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_18010 || 0);

      const target =
        Number(targetFIC_18010 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_18010: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_18010]);


/* =========================================================
   TOTAL PUMP FLOW
========================================================= */

const InjectionWater =
  Number(
    (
      FIC_18009 +
      FIC_18010
    ).toFixed(3)
  );


/* =========================================================
   DISCHARGE PRESSURE
========================================================= */

const PT_18003 =
  P109_Running &&
  totalOpening109 > 0
    ? 0.85
    : 0.03;


/* =========================================================
   DISCHARGE TEMPERATURE
========================================================= */

const TT_18003 =
  P109_Running
    ? Number(TT_18001 || 25)
    : 25;





    const FIC_18012 = flowOverrides?.FIC_18012 ? 0 : (xv18006Open ? FIC_18001*0.00253 : 0);
    const PT_18004 =(PT_18001 * 0.93) + BackPressureFactor;
    const TT_18004 = xv18006Open ? TT_18001*0.987 : 26;
    
    const FIC_18013 = xv18007Open ? 3.0495 : 0;






useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_18005 === FIC_18005 &&
    current.FIC_18006 === FIC_18006 &&
    current.FIC_18007 === FIC_18007 &&
    current.FIC_18008 === FIC_18008 &&
    current.FIC_18009 === FIC_18009 &&
    current.FIC_18010 === FIC_18010 &&
    current.FIC_18012 === FIC_18012 &&
    current.FIC_18004 === FIC_18004 &&
    current.PT_18004 === PT_18004 &&
    current.TT_18004 === TT_18004 &&
    current.TT_18002 === TT_18002 &&
    current.TT_18007 === TT_18007 &&
    current.TT_18008 === TT_18008 &&
    current.PT_18007 === PT_18007 &&
    current.PT_18008 === PT_18008 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_18005, FIC_18006, FIC_18007, FIC_18008, FIC_18009, FIC_18010, FIC_18012, PT_18004, FIC_18004, TT_18004, TT_18002, TT_18007, TT_18008, PT_18007, PT_18008
    }
  });

}, [FIC_18005, FIC_18006, FIC_18007, FIC_18008, FIC_18009, FIC_18010, FIC_18012, PT_18004, FIC_18004, TT_18004, TT_18002, TT_18007, TT_18008, PT_18007, PT_18008]);








  return (
    <div className="PFRefluxCond2-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 303px",
          zIndex: 10,
        }}
      >
        T-101 NAPHTHA REFLUX SYSTEM
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-18001 */}
      <Valve
        className="XV-18001"
        tag="XV_18001"
        x={1117}
        y={271}
        isClosed={valves.XV_18001}
        toggle={toggleValve}
      />

      {/* XV-18002 */}
      <Valve
        className="XV-18002"
        tag="XV_18002"
        x={1117}
        y={341}
        isClosed={valves.XV_18002}
        toggle={toggleValve}
      />

      {/* XV-18003 */}
      <Valve
        className="XV-18003"
        tag="XV_18003"
        x={592}
        y={327}
        isClosed={valves.XV_18003}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-18004 */}
      <Valve
        className="XV-18004"
        tag="XV_18004"
        x={265}
        y={121}
        isClosed={valves.XV_18004}
        toggle={toggleValve}
      />

      {/* XV-18005 */}
      <Valve
        className="XV-18005"
        tag="XV_18005"
        x={265}
        y={187}
        isClosed={valves.XV_18005}
        toggle={toggleValve}
      />

      {/* XV-18006 */}
      <Valve
        className="XV-18006"
        tag="XV_18006"
        x={1165}
        y={87}
        isClosed={valves.XV_18006}
        toggle={toggleValve}
      />

      {/* XV-18007 */}
      <Valve
        className="XV-18007"
        tag="XV_18007"
        x={925}
        y={113}
        isClosed={valves.XV_18007}
        toggle={toggleValve}
      />


      <button
        onClick={() => setShowLab(true)}
        className="mds-btn"
        style={{
          position: "absolute",
          left: "1150px",
          top: "30px",
          zIndex: 500
        }}
        
      >
        LAB REPORT
      </button> 

      {showLab && (
        <LaboratoryAnalysisFaceplate
          close={() => setShowLab(false)}
        />
      )}




      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-18001 */}
        <div
            style={{ position: "absolute", left: 967, top: 323, transform: "rotate(270deg)", transformOrigin: "center"}}
            onMouseEnter={() => setHoveredValve("FCV_18001")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_18001")}
          >

            {hoveredValve === "FCV_18001" && (
              <div style={tagStyle}>
                FCV_18001
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-18001">
                    
          <defs>
            <linearGradient id="metal_18001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_18001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_18001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-18002 */}
        <div
            style={{ position: "absolute", left: 290, top: 321}}
            onMouseEnter={() => setHoveredValve("FCV_18002")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_18002")}
          >

            {hoveredValve === "FCV_18002" && (
              <div style={tagStyle}>
                FCV_18002
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-18002">
                    
          <defs>
            <linearGradient id="metal_18002">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_18002)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_18002)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-18003 */}
        <div
            style={{ position: "absolute", left: 290, top: 399}}
            onMouseEnter={() => setHoveredValve("FCV_18003")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_18003")}
          >

            {hoveredValve === "FCV_18003" && (
              <div style={tagStyle}>
                FCV_18003
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-18003">
                    
          <defs>
            <linearGradient id="metal_18003">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_18003)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_18003)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      



     
       

        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



 {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_18001?.opening || 0)}
        x={1022}
        y={342}
      />

      <ValveOutput
        value={Number(valveData?.FCV_18002?.opening || 0)}
        x={312}
        y={365}
      />

      <ValveOutput
        value={Number(valveData?.FCV_18003?.opening || 0)}
        x={312}
        y={443}
      />



        <Transmitter
          tag="TT_18001"
          value={[TT_18001]}
          x={212}
          y={63}
          unit="°C"
          max={100}
          HH={86}
          H={60}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CONDENSED OVERHEAD VAPOR AT THE TOP OF PREFLASH FRACTIONATION TOWER (T-101) TO V-101"
         />


         <Transmitter
          tag="PT_18001"
          value={[PT_18001]}
          x={352}
          y={63}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF CONDENSED OVERHEAD VAPOR AT THE TOP OF PREFLASH FRACTIONATION TOWER (T-101) TO V-101"
         />


         <Transmitter
          tag="FIC_18001"
          value={[FIC_18001]}
          x={492}
          y={63}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CONDENSED OVERHEAD VAPOR AT THE TOP OF PREFLASH FRACTIONATION TOWER (T-101) TO V-101"
         />

         <Transmitter
          tag="FIC_18002"
          value={[FIC_18002]}
          x={152}
          y={108}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRODUCED WATER FROM V-302 TO V-101"
         />

         <Transmitter
          tag="FIC_18003"
          value={[FIC_18003]}
          x={152}
          y={173}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRODUCED WATER FROM V-301 TO V-101"
         />

         <Transmitter
          tag="FIC_18006"
          value={[FIC_18006]}
          x={1022}
          y={523}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF NAPHTHA FROM P-102A/B"
         />

         <Transmitter
          tag="PT_18002"
          value={[PT_18002]}
          x={832}
          y={563}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF NAPHTHA FROM P-102A/B"
         />

         <Transmitter
          tag="TT_18002"
          value={[TT_18002]}
          x={962}
          y={590}
          unit="°C"
          max={100}
          HH={86}
          H={60}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF NAPHTHA FROM P-102A/B"
         />


         <Transmitter
          tag="FIC_18005"
          value={[FIC_18005]}
          x={1082}
          y={433}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF NAPHTHA NAPHTHA REFLUX FROM P-102A/B TO T-101"
         />


         <Transmitter
          tag="FIC_18004"
          value={[FIC_18004]}
          x={882}
          y={333}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF NAPHTHA NAPHTHA FROM P-102A/B TO V-301"
         />

         <Transmitter
          tag="FIC_18009"
          value={[FIC_18009]}
          x={162}
          y={313}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRODUCED WATER FOR WATER INJECTION AT T-101"
         />

         <Transmitter
          tag="FIC_18010"
          value={[FIC_18010]}
          x={162}
          y={393}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRODUCED WATER FOR WATER INJECTION AT T-102"
         />

         <Transmitter
          tag="FIC_18011"
          value={[FIC_18011]}
          x={502}
          y={333}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRODUCED WATER DRAINAGE FROM V-101 TO SUMP"
         />


         <Transmitter
          tag="PT_18003"
          value={[PT_18003]}
          x={362}
          y={563}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF PRODUCED WATER INJECTION FROM P-109"
         />

         <Transmitter
          tag="TT_18003"
          value={[TT_18003]}
          x={362}
          y={513}
          unit="°C"
          max={100}
          HH={86}
          H={60}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF PRODUCED WATER INJECTION FROM P-109"
         />

          <Transmitter
          tag="FIC_18007"
          value={[FIC_18007]}
          x={1172}
          y={233}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PREFLASHED NAPHTHA PRODUCED FROM P-102A/B TO V-301"
         />

          <Transmitter
          tag="FIC_18008"
          value={[FIC_18008]}
          x={1182}
          y={313}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PREFLASHED NAPHTHA PRODUCED FROM P-102A/B TO UNQUALIFIED LINE"
         />

          <Transmitter
          tag="FIC_18012"
          value={[FIC_18012]}
          x={822}
          y={73}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF NON CONDENSABLE LOW PRESSURE GASES FROM V-101 TO V-505"
         />


         <Transmitter
          tag="PT_18004"
          value={[PT_18004]}
          x={932}
          y={73}
          unit="MPa"
          max={1}
          HH={0.8}
          H={0.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF NON CONDENSABLE LOW PRESSURE GASES FROM V-101 TO V-505"
         />

         <Transmitter
          tag="TT_18004"
          value={[TT_18004]}
          x={1032}
          y={73}
          unit="°C"
          max={100}
          HH={86}
          H={60}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF NON CONDENSABLE LOW PRESSURE GASES FROM V-101 TO V-505"
         />







         
    <LevelTransmitterIndicator
      tag="LT_18001"
      totalLevel={500}
      inflows={[FIC_18001+FIC_18013]}
      outflows={[FIC_18006+FIC_18012]}
      inflowTags={["FIC_18001", "FIC_18013"]}
      outflowTags={["FIC_18006", "FIC_18012"]}
      responseFactor={0.05}
      columnX={559}
      columnY={172}
      columnWidth={306}
      columnHeight={121}
      textX={899}
      textY={182}
      showFlow={true}
      backgroundOpacity={0.00}
      liquidOpacity={0.6}
      service="naphtha"
    />

    <LevelTransmitterIndicator
      tag="LT_18002"
      totalLevel={500}
      inflows={[FIC_18002+FIC_18003 + (FIC_18001*0.09)]}
      outflows={[FIC_18009+FIC_18010+FIC_18011]}
      inflowTags={["FIC_18002", "FIC_18003", "FIC_18001"]}
      outflowTags={["FIC_18009", "FIC_18010", "FIC_18011"]}
      responseFactor={0.05}
      columnX={559}
      columnY={172}
      columnWidth={306}
      columnHeight={121}
      textX={446}
      textY={182}
      showFlow={true}
      backgroundOpacity={0.00}
      liquidOpacity={0.4}
      service="water"
    />









            <Pump
              tag="P-102A"
              x={735}
              y={525}
              rpm={1800}
              bladeCount={pumpData?.["P-102A"]?.bladeCount || 3}
              size={pumpData?.["P-102A"]?.size || 43}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-102B"
              x={735}
              y={608}
              rpm={1800}
              bladeCount={pumpData?.["P-102B"]?.bladeCount || 3}
              size={pumpData?.["P-102B"]?.size || 43}
              onClick={openPumpPanel}
            />


            <Pump
              tag="P-109"
              x={504}
              y={572}
              rpm={1800}
              bladeCount={pumpData?.["P-109"]?.bladeCount || 3}
              size={pumpData?.["P-109"]?.size || 43}
              onClick={openPumpPanel}
            />










       

    </div>
  );
}

export default PFRefluxCond2;